import React from 'react';

const About = () => (
    <div className="about-container">
        <h1 className="about-title">About</h1>
        <p className="about-p"> 
        This website was created to show my skill set in "React", a JavaScript library for building user interfaces. 
        I've recently finished a JavaScript front-end course and decided to try out React. 
        So far, I've enjoyed learning React, and from what you can see I'm not having as much trouble mastering it as I thought I would. 
        My goal is to become a front-end developer, and I'm going to keep mastering as many programming languages as I can. 
        I hope you enjoy the website, and wish me luck on my journey to becoming a front-end developer!
        </p>
    </div>
);

export default About;